module.exports = __webpack_public_path__ + "img/i10.7764646b.svg";